var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVal6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2400_36165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.804 51.5225C19.0214 50.509 15.4755 48.7604 12.3687 46.3765C9.26194 43.9926 6.65513 41.0201 4.69713 37.6287C2.73914 34.2374 1.46829 30.4936 0.957154 26.6111C0.44602 22.7286 0.704609 18.7834 1.71815 15.0009V15.0009C17.6261 19.2633 27.0665 35.6146 22.804 51.5225V51.5225Z",
    fill: "#FF7D85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5112 51.522C26.2938 50.5084 29.8397 48.7598 32.9465 46.3759C36.0533 43.9919 38.6601 41.0194 40.6181 37.6281C42.5761 34.2367 43.8469 30.4929 44.3581 26.6104C44.8692 22.7278 44.6106 18.7827 43.597 15.0001V15.0001C27.6891 19.2627 18.2487 35.6141 22.5112 51.522V51.522Z",
    fill: "#47BDFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_36165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVal6);
export default __webpack_public_path__ + "static/media/val6.28a0e844c43df3a46953f2134ca12966.svg";
export { ForwardRef as ReactComponent };